import { Box, CircularProgress, Container, Grid2 } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { calculateCreatedAgo, sortArrList } from '../../commonFunc';
import { getAllNews } from '../../../providers/apis/blogApi';
import { getNewsGraphic2Url, resolveContentMedia } from '../../../pages/new/helper/graphic2';
import { HubListingCardLink } from '../../../pages/new/layout/HubListingCardLink';
import { ListingCardImage } from '../../../pages/new/layout/ListingCardImage';

const NEWS_PREVIEW_LIMIT = 4;

function parseNews(newsRes) {
  return newsRes.map((nItem) => ({
    postId: nItem.Id,
    title: nItem.Title,
    postMedia: resolveContentMedia(nItem, getNewsGraphic2Url),
    postDate: nItem.DatePublished,
    postType: nItem.ContentType || 'news',
    postName: nItem.Relevance,
    link: nItem.Source,
    hasBody: nItem.hasBody,
  }));
}

export const LastNews = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadNews = async () => {
      setLoading(true);
      try {
        const newsRes = await getAllNews();
        const sortedNews = sortArrList(parseNews(newsRes));
        setItems(sortedNews.slice(0, NEWS_PREVIEW_LIMIT));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, []);

  return (
    <Box className="w-full bg-[#F9F9F9] py-20">
      <Container maxWidth="lg">
        <Box className="w-full">
          <Box
            className="w-full"
            display="flex"
            flexDirection={{ xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' }}
            justifyContent="space-between"
            alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center', lg: 'center', xl: 'center' }}
          >
            <h4 className="text-[42px] leading-[54.6px] font-medium">Latest News</h4>
            <Link to="/articles/news">
              <button
                type="button"
                className="text-[18px] font-medium leading-[24px] rounded-full border border-[#021744] hover:bg-[#021744] hover:text-white px-8 py-4"
              >
                View all news
              </button>
            </Link>
          </Box>
          <Box className="w-full py-14">
            {loading ? (
              <Box className="w-full flex justify-center items-center min-h-[220px]">
                <CircularProgress />
              </Box>
            ) : (
              <Grid2 container spacing={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                {items.map((itemData, key) => (
                  <Grid2
                    key={`${itemData.postId ?? key}-${key}`}
                    size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                  >
                    <HubListingCardLink item={itemData}>
                      <Box className="w-full">
                        <div className="cursor-pointer w-full aspect-video rounded-xl overflow-hidden">
                          <ListingCardImage
                            mediaPath={itemData.postMedia}
                            title={itemData.title}
                            postType={itemData.postType}
                            alt={`${itemData.title} — Charlee.ai news article thumbnail`}
                            containerClassName="w-full aspect-video rounded-xl"
                            imageClassName="w-full aspect-video rounded-xl object-cover transition-transform duration-300 ease-out group-hover:scale-105"
                            showFallbackTitle={false}
                          />
                        </div>
                        <h5 className="cursor-pointer text-start text-[24px] leading-[32px] font-normal line-clamp-2 my-5">
                          {itemData.title}
                        </h5>
                      </Box>
                      <Box className="cursor-pointer w-full text-start my-6 text-[#949494] text-[12px] leading-[21px]">
                        <span>{calculateCreatedAgo(itemData)}</span>
                      </Box>
                    </HubListingCardLink>
                  </Grid2>
                ))}
              </Grid2>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
